import dayjs from 'dayjs';

import I18n from '@utils/i18n';

// dayjs 插件统一在pages/_app.js管理

// import isToday from 'dayjs/plugin/isToday';
// import isYesterday from 'dayjs/plugin/isYesterday';
// import relativeTime from 'dayjs/plugin/relativeTime'
// import 'dayjs/locale/zh-cn'

// dayjs.locale('zh-cn')
// dayjs.extend(isToday);
// dayjs.extend(isYesterday);
// dayjs.extend(relativeTime);

const weekList = () => [
  I18n.t('LO6BwVcc'),
  I18n.t('kPcD0Lbg'),
  I18n.t('XqxuRmzi'),
  I18n.t('LCfJ5cOv'),
  I18n.t('YIyf2xOg'),
  I18n.t('3mFBPUVY'),
  I18n.t('OOxCpdDq')
];

export const getWeek = (time = dayjs()) => {
  const date = dayjs(time).format('MM/DD');
  let day = ''; // 当前时间
  const week = weekList()[dayjs(time).day()];
  if (dayjs(time).isToday()) {
    day = I18n.t('v2PRNeVa');
  }
  if (dayjs(time).isYesterday()) {
    day = I18n.t('XSZ85Mw2');
  }
  return {
    date,
    week,
    day
  };
};

// 当天：5分钟前/5小时前
// 当天之前：08/28 16:09
export const customizeRelativeTime = (time = dayjs()) => {
  if (dayjs(time).isToday()) {
    return dayjs().to(dayjs(time));
  }
  return dayjs(time).format('MM/DD HH:mm');
};
